import React from "react";
import parse from 'html-react-parser';
import { isNull, isNullOrUndefined } from "../Utility/index";
import LogoComponent from "./LogoComponent";
import {convertTextToScreen, getPathForApiCall} from "../Utility/ConditionValidator";

class WelcomeComponent extends React.Component {
  constructor(props) {
    super(props);
    this.parseContextVariable = this.parseContextVariable.bind(this);
  }
  parseContextVariable(content) {
    const { conduct } = this.props;

    var replacements = {};
    conduct.contextVariables.forEach(function(ctx) {
      replacements[`{${ctx.name}}`] = decodeURIComponent(ctx.value);
    });

    var parseContent = content.replace(/{\w+}/g, function(a) {
      return replacements[a] || a;
    });
    parseContent = parseContent.replace(/\{\w+\}/g, '');

    return parseContent;
  }
  render() {
    const { surveyTitle, welcomeContent } = this.props.conduct.surveyContent;
    const { key, surveyID, surveyLanguages, isPublish, currentLanguageID } = this.props.conduct;

    const switchLanguage = (langID) => {
      if (langID !== currentLanguageID && this.props.setLanguages) {
        const pathForApiCall = getPathForApiCall();
        this.props.setLanguages(pathForApiCall, key, surveyID, langID, isPublish);
      }
    };

    return (
      <div className="page_body">
        <LogoComponent conduct={this.props.conduct} />
        {!isNull(surveyTitle) ? (
          <div className="welcome_title">
            <span className="welcome_title_content">{surveyTitle}</span>
          </div>
        ) : (
          ""
        )}

        {isNullOrUndefined(welcomeContent) ? (
          ""
        ) : (
          <div className="welcome_description">
            {parse(this.parseContextVariable(convertTextToScreen(welcomeContent)))}
          </div>
        )}

        {surveyLanguages && surveyLanguages.length > 1 && (
          <div className="welcome_language_switcher" style={{ marginTop: '40px', textAlign: 'center', color: '#687787', fontSize: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.6334 11.6667C13.7 11.1167 13.75 10.5667 13.75 10.0001C13.75 9.43341 13.7 8.88341 13.6334 8.33341H16.45C16.5834 8.86675 16.6667 9.42508 16.6667 10.0001C16.6667 10.5751 16.5834 11.1334 16.45 11.6667M12.1584 16.3001C12.6584 15.3751 13.0417 14.3751 13.3084 13.3334H15.7667C14.9593 14.7236 13.6784 15.7767 12.1584 16.3001ZM11.95 11.6667H8.05002C7.96669 11.1167 7.91669 10.5667 7.91669 10.0001C7.91669 9.43341 7.96669 8.87508 8.05002 8.33341H11.95C12.025 8.87508 12.0834 9.43341 12.0834 10.0001C12.0834 10.5667 12.025 11.1167 11.95 11.6667ZM10 16.6334C9.30835 15.6334 8.75002 14.5251 8.40835 13.3334H11.5917C11.25 14.5251 10.6917 15.6334 10 16.6334ZM6.66669 6.66675H4.23335C5.03222 5.27261 6.31224 4.21778 7.83335 3.70008C7.33335 4.62508 6.95835 5.62508 6.66669 6.66675ZM4.23335 13.3334H6.66669C6.95835 14.3751 7.33335 15.3751 7.83335 16.3001C6.31524 15.777 5.03693 14.7236 4.23335 13.3334ZM3.55002 11.6667C3.41669 11.1334 3.33335 10.5751 3.33335 10.0001C3.33335 9.42508 3.41669 8.86675 3.55002 8.33341H6.36669C6.30002 8.88341 6.25002 9.43341 6.25002 10.0001C6.25002 10.5667 6.30002 11.1167 6.36669 11.6667M10 3.35841C10.6917 4.35841 11.25 5.47508 11.5917 6.66675H8.40835C8.75002 5.47508 9.30835 4.35841 10 3.35841ZM15.7667 6.66675H13.3084C13.0471 5.63476 12.661 4.6385 12.1584 3.70008C13.6917 4.22508 14.9667 5.28341 15.7667 6.66675ZM10 1.66675C5.39169 1.66675 1.66669 5.41675 1.66669 10.0001C1.66669 12.2102 2.54466 14.3298 4.10746 15.8926C4.88129 16.6665 5.79994 17.2803 6.81099 17.6991C7.82204 18.1179 8.90567 18.3334 10 18.3334C12.2102 18.3334 14.3298 17.4554 15.8926 15.8926C17.4554 14.3298 18.3334 12.2102 18.3334 10.0001C18.3334 8.90573 18.1178 7.8221 17.699 6.81105C17.2802 5.80001 16.6664 4.88135 15.8926 4.10752C15.1188 3.3337 14.2001 2.71987 13.189 2.30109C12.178 1.8823 11.0944 1.66675 10 1.66675Z" fill="#637381"/>
            </svg>
            {surveyLanguages.map((v, i) => {
              const isActive = v.languageID === currentLanguageID;
              const text = v.languageName === 'CN' ? '中文' : v.languageName === 'EN' ? 'English' : v.languageName === 'TH' ? 'ภาษาไทย' : v.languageName;
              return (
                <span key={`lang_switch_${i}`} style={{ display: 'flex', alignItems: 'center' }}>
                  <span
                    onClick={() => switchLanguage(v.languageID)}
                    style={{
                      cursor: 'pointer',
                      color: isActive ? '#687787' : '#B0BAC5',
                      padding: '0 8px',
                    }}
                  >
                    {text}
                  </span>
                  {i < surveyLanguages.length - 1 && <span style={{ color: '#B0BAC5' }}>|</span>}
                </span>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}
export default WelcomeComponent;
